export enum PaymentMethods {
  ONLINE = 'online',
  WALLET = 'wallet',
  CARD = 'card'
}

export interface StartPaymentResource {
  id: number
  gateway: string
  amount: number
  payable: number
  description: string
  ref_id: string
  deficit?: number | null
  wallet_amount?: number
  payment_link: PaymentLink
  verify_url: string
}

export interface PaymentLink {
  url: string
  method: string
  params: any[]
}

export interface OwnBankInfoModel {
  sheba: string;
  name: string;
  bank_name: string;
}


export interface PaymentLinkRequest {
  coupon_code?: string
  gateway: PaymentMethods
  attachment?: File | File[]
}